import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SaveFilterComponent } from './save-filter.component';
import { FormsModule } from '@angular/forms';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
  imports: [
    InputsModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    DialogsModule,
    ButtonsModule,
    DropDownsModule
  ],
  declarations: [
    SaveFilterComponent
  ],
  exports: [
    SaveFilterComponent
  ]
})
export class SaveFilterModule { }
